// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-sub-supplier-information-guidelines.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-sub-supplier-information-guidelines',
  title: 'Maintain guidelines specifying what customer information is shared with sub-suppliers',
  description:
    'The organisation must maintain documented guidelines that specify: which types of customer information may be shared with sub-suppliers; and what access sub-suppliers are granted to IT infrastructure, networks and physical environments. These guidelines must be reviewed when sub-supplier relationships change.',
  category: 'vendors',
  scfIds: ['SCF-VDR-002', 'SCF-DAT-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Sub-supplier information sharing guidelines are published',
    },
    { type: 'document-within-sla', description: 'Guidelines review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
